module.exports = __webpack_public_path__ + "static/media/operation.45c05740.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Fiber/images/operation.svg
// module id = 1292
// module chunks = 0